import React from "react";
import Image from "next/image";
import cn from "classnames";
import Slider from "react-slick";
import styles from "./styles.module.scss";

const ProductSlider = () => {
  const settings = {
    dots: false,
    speed: 500,
    autoplay: true,
    autoplaySpeed: 5000,
    pauseOnHover: false,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          dots: true,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: true,
        },
      },
    ],
  };

  return (
    <div className="container">
      <div className={cn(styles.slider)}>
        <div className={cn(styles.text)}>
          <label className="h4">Win back lapsed subscribers</label>
          <p className="text_xl">
            Create rules to win back lapsed customers by giving them a discount.
            <br />
            Create promo paywalls and surveys in Visual Editor with no coding.
          </p>
        </div>
        <div className={cn(styles.wrapper)}>
          <Slider {...settings} className={styles.slick}>
            <div className={styles.slide}>
              <Image
                src="/images/product-slider/image1.svg"
                width="236"
                height="245"
                alt="chart"
                loading="lazy"
              />
              <p>When a user cancels trial or subscription...</p>
            </div>
            <div className={styles.slide}>
              <Image
                src="/images/product-slider/image2.svg"
                width="281"
                height="246"
                alt="metrics"
                loading="lazy"
              />
              <p>...we will ask a user to pass the survey</p>
            </div>
            <div className={styles.slide}>
              <Image
                src="/images/product-slider/image3.svg"
                width="236"
                height="245"
                alt="user information"
                loading="lazy"
              />
              <p>If the subscription was too expensive to a user...</p>
            </div>
            <div className={styles.slide}>
              <Image
                src="/images/product-slider/image4.svg"
                width="236"
                height="246"
                alt="user information"
                loading="lazy"
              />
              <p>...we’ll offer a discount or new trial to win him back</p>
            </div>
          </Slider>
        </div>
      </div>
    </div>
  );
};

export default ProductSlider;
